{
  "route": "field",
  "railEntries": [
    {
      "label": "Orientation",
      "anchor": "field-section-1"
    },
    {
      "label": "Research verdict",
      "anchor": "field-section-2"
    },
    {
      "label": "Four fields",
      "anchor": "field-section-3"
    }
  ],
  "anchors": [
    "field-section-1",
    "field-section-2",
    "field-section-3"
  ],
  "nodes": [
    {
      "tag": "section",
      "attrs": {
        "class": "route",
        "id": "route-field",
        "aria-labelledby": "field-title"
      },
      "children": [
        {
          "tag": "div",
          "attrs": {
            "class": "wrap"
          },
          "children": [
            {
              "tag": "div",
              "attrs": {
                "class": "hero",
                "id": "field-section-1"
              },
              "children": [
                {
                  "tag": "div",
                  "attrs": {
                    "class": "hero-copy"
                  },
                  "children": [
                    {
                      "tag": "p",
                      "attrs": {
                        "class": "eyebrow"
                      },
                      "children": [
                        "Your research field guide · August 2026 · synthesis v0.1"
                      ]
                    },
                    " ",
                    {
                      "tag": "h1",
                      "attrs": {
                        "id": "field-title"
                      },
                      "children": [
                        "The world ",
                        {
                          "tag": "em",
                          "children": [
                            "between stars."
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "p",
                      "attrs": {
                        "class": "hero-deck"
                      },
                      "children": [
                        "Not a verdict on which future wins. A way to build through breakthrough, breakdown, and the uneven territory where both arrive at once."
                      ]
                    },
                    " ",
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "hero-note"
                      },
                      "children": [
                        {
                          "tag": "span",
                          "attrs": {
                            "class": "status-dot"
                          },
                          "children": []
                        },
                        "Research synthesis · not a public manifesto yet"
                      ]
                    },
                    " "
                  ]
                },
                " ",
                {
                  "tag": "div",
                  "attrs": {
                    "class": "field-map",
                    "aria-label": "Stellar, Earth 2.0 and collapse-aware thinking converging into Earth 3.0"
                  },
                  "children": [
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "map-axis",
                        "aria-hidden": "true"
                      },
                      "children": []
                    },
                    " ",
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "signal signal-a"
                      },
                      "children": [
                        {
                          "tag": "strong",
                          "children": [
                            "Stellar"
                          ]
                        },
                        {
                          "tag": "span",
                          "children": [
                            "Technical abundance · phase change · sunrise"
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "signal signal-b"
                      },
                      "children": [
                        {
                          "tag": "strong",
                          "children": [
                            "I Eat the Stars"
                          ]
                        },
                        {
                          "tag": "span",
                          "children": [
                            "Systemic decline · human depth · ground"
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "signal signal-c"
                      },
                      "children": [
                        {
                          "tag": "strong",
                          "children": [
                            "Earth 2.0"
                          ]
                        },
                        {
                          "tag": "span",
                          "children": [
                            "Mandate · composed room · crossing"
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "crossing"
                      },
                      "children": [
                        {
                          "tag": "div",
                          "children": [
                            {
                              "tag": "span",
                              "attrs": {
                                "class": "small"
                              },
                              "children": [
                                "The integrated field"
                              ]
                            },
                            {
                              "tag": "b",
                              "children": [
                                "Earth 3.0"
                              ]
                            },
                            {
                              "tag": "p",
                              "children": [
                                "Adaptive transition infrastructure that works through both futures."
                              ]
                            }
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "field-caption"
                      },
                      "children": [
                        "Breakthrough above · disruption below · governance at the crossing"
                      ]
                    },
                    " "
                  ]
                },
                " "
              ]
            },
            " ",
            {
              "tag": "div",
              "attrs": {
                "class": "opening-verdict"
              },
              "children": [
                {
                  "tag": "div",
                  "attrs": {
                    "class": "verdict-card",
                    "id": "field-section-2"
                  },
                  "children": [
                    {
                      "tag": "div",
                      "attrs": {
                        "class": "verdict-label"
                      },
                      "children": [
                        "The research verdict",
                        {
                          "tag": "span",
                          "children": [
                            "You have not lost the model. The second book changes its operating conditions."
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "p",
                      "attrs": {
                        "class": "verdict-copy"
                      },
                      "children": [
                        "The core is right. The upgrade is temporal: from building ",
                        {
                          "tag": "em",
                          "children": [
                            "before the shock"
                          ]
                        },
                        " to governing ",
                        {
                          "tag": "em",
                          "children": [
                            "before, through and beyond it."
                          ]
                        }
                      ]
                    },
                    " "
                  ]
                },
                " ",
                {
                  "tag": "div",
                  "attrs": {
                    "class": "four-fields",
                    "aria-label": "The four fields in this synthesis",
                    "id": "field-section-3"
                  },
                  "children": [
                    {
                      "tag": "a",
                      "attrs": {
                        "class": "field-card stellar",
                        "href": "#stellar",
                        "data-route": "stellar"
                      },
                      "children": [
                        {
                          "tag": "span",
                          "attrs": {
                            "class": "num"
                          },
                          "children": [
                            "01 · POSSIBILITY"
                          ]
                        },
                        {
                          "tag": "h2",
                          "children": [
                            "The Sunrise"
                          ]
                        },
                        {
                          "tag": "p",
                          "children": [
                            "Stellar supplies a destination and a theory of rapid technological phase change."
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "a",
                      "attrs": {
                        "class": "field-card earth2",
                        "href": "#earth2",
                        "data-route": "earth2"
                      },
                      "children": [
                        {
                          "tag": "span",
                          "attrs": {
                            "class": "num"
                          },
                          "children": [
                            "02 · GOVERNANCE"
                          ]
                        },
                        {
                          "tag": "h2",
                          "children": [
                            "The Crossing"
                          ]
                        },
                        {
                          "tag": "p",
                          "children": [
                            "Earth 2.0 supplies the missing mandate, room and stewardship architecture."
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "a",
                      "attrs": {
                        "class": "field-card stars",
                        "href": "#stars",
                        "data-route": "stars"
                      },
                      "children": [
                        {
                          "tag": "span",
                          "attrs": {
                            "class": "num"
                          },
                          "children": [
                            "03 · REALITY"
                          ]
                        },
                        {
                          "tag": "h2",
                          "children": [
                            "The Ground"
                          ]
                        },
                        {
                          "tag": "p",
                          "children": [
                            "I Eat the Stars supplies collapse awareness, emotional truth and local human capacity."
                          ]
                        }
                      ]
                    },
                    " ",
                    {
                      "tag": "a",
                      "attrs": {
                        "class": "field-card earth3",
                        "href": "#earth3",
                        "data-route": "earth3"
                      },
                      "children": [
                        {
                          "tag": "span",
                          "attrs": {
                            "class": "num"
                          },
                          "children": [
                            "04 · INTEGRATION"
                          ]
                        },
                        {
                          "tag": "h2",
                          "children": [
                            "The Third Way"
                          ]
                        },
                        {
                          "tag": "p",
                          "children": [
                            "Earth 3.0 holds uncertainty and turns it into a practical transition portfolio."
                          ]
                        }
                      ]
                    },
                    " "
                  ]
                },
                " "
              ]
            },
            " ",
            {
              "tag": "footer",
              "attrs": {
                "class": "tiny-footer"
              },
              "children": [
                {
                  "tag": "span",
                  "children": [
                    "Earth 3.0 · The Third Way"
                  ]
                },
                {
                  "tag": "span",
                  "children": [
                    "Research and synthesis · The Legacy Impact Studio"
                  ]
                }
              ]
            },
            " "
          ]
        },
        " "
      ]
    },
    " "
  ]
}
